module.exports = __webpack_public_path__ + "img/hero-image-compra.ccdaea05.png";